export default {
    dictDefaultMessage: 'Bestanden toevoegen',
    dictFallbackMessage:
        'Uw browser ondersteunt geen uploads door slepen en neerzetten',
    dictFallbackText: 'Gebruik onderstaande formulier om bestanden te uploaden',
    dictFileTooBig:
        'Bestand te groot ({{filesize}}MB). Maximale bestandsgrootte: {{maxFilesize}}MB.',
    dictInvalidFileType: 'Dit bestandstype is niet toegestaan.',
    dictResponseError: 'Server antwoordde met code {{statusCode}}.',
    dictCancelUpload: 'Upload annuleren',
    dictCancelUploadConfirmation:
        'Bent u zeker dat u deze upload wilt annuleren?',
    dictRemoveFile: 'Verwijderen',
    dictMaxFilesExceeded: 'De bestandslimiet is bereikt',
};
